import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Form from "./CustomNewsForm";
import { LOADING, MODE } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

// Fields specific to news
const fields = [
  { label: "Title", name: "title", placeholder: "Enter Title", required: true },
 
  {
    label: "Description",
    name: "description",
    placeholder: "Enter full description",
    type: "rich-text",
    required: true,
  },
  {
    label: "Image",
    name: "image",
    placeholder: "Choose Image",
    type: "file",
  },
];

const EditNews = () => {
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const loadNewsData = async () => {
      if (!id) return;

      try {
        const response = await axios.get(`${API_URL}/news/getNewsById/${id}`);
        
        // Log response data to inspect structure
        console.log("API response data:", response.data);

        // Use response.data directly if data is not nested in a "data" field
        const newsData = response.data;
        
        if (newsData) {
          setInitialData({
            ...newsData,
            image: newsData.image,
          });
          setImagePreview(newsData.image || "");
        } else {
          throw new Error("News data not found");
        }
      } catch (error) {
        console.error("Error loading news data:", error);
        toast.error("Error loading news data");
      }
    };

    loadNewsData();
  }, [id]);

  const handleSubmit = async (formData) => {
    try {
      await axios.put(`${API_URL}/news/updateNewsById/${id}`, formData);
      toast.success("News updated successfully", { autoClose: 1000 });
      navigate("/news");
    } catch (error) {
      console.error("Error updating news:", error);
      toast.error("Error updating news", { autoClose: 1000 });
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Update News
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/news")}
        >
          &times;
        </button>
      </div>
      {initialData ? (
        <Form
          mode={MODE.UPDATE}
          onSubmit={handleSubmit}
          fields={fields}
          initialData={initialData}
          imagePreview={imagePreview}
        />
      ) : (
        <p>{LOADING}</p>
      )}
    </div>
  );
};

export default EditNews;
